<script lang="ts">
import { mapActions, mapGetters } from "vuex"
import SidebarMenuNew from "@/components/SidebarMenu.vue"

import FilteredSearch from "@/components/search/FilteredSearch.vue"
import { nextTick } from "vue"
import MojElektroFilters from "./external/moj-elektro/MojElektroFilters.vue"

export default {
    name: "Sidebar",
    components: {
        SidebarMenuNew,
        FilteredSearch,
        MojElektroFilters,
    },
    props: {},
    data() {
        return {
            isOnMobile: false,
            query: "",
            openItemId: null as string | null,
            isFooterOpen: true,
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
            isMenuRendering: true,
        }
    },
    methods: {
        ...mapActions("sidebar", {
            fetchMenu: "fetchMenu",
            setSidebarVisibility: "setSidebarVisibility",
            toggleVisibility: "toggleVisibility",
            setMenu: "setMenu",
            setLoading: "setLoading",
            setInputFocused: "setInputFocused",
        }),
        handleResize() {
            this.windowWidth = window.innerWidth
            this.windowHeight = window.innerHeight
        },
        closeSidebar() {
            if (this.isOnMobile) {
                this.setSidebarVisibility(false)
            }

            const isAdmin = this.$permissions.hasSuperAdminRole() ? this.companyId : null

            const user = this.$auth.user()

            //@ts-ignore Fix type
            if (user.role === "ROLE_USER_BASIC") {
                this.isMenuRendering = true
                this.fetchMenu(isAdmin).then(() => {
                    this.processRouteChange()
                })
            } else {
                this.isMenuRendering = true
                this.fetchMenu(isAdmin).then(() => {
                    this.processRouteChange()
                })

                this.setLoading(false)
            }
        },
        onItemClick(event: any, item: any) {
            this.$store.commit("reduxi/setPageTitle", item.title)
        },
        onItemClick2() {
            if (this.isOnMobile) {
                this.setSidebarVisibility(false)
            }
        },
        onBackButtonClick() {
            this.$router.go(-1)
        },
        logout() {
            this.$store.dispatch("auth/logout")
            this.$router.push("/auth/login").catch(() => {})
        },
        onResize() {
            this.isOnMobile = window.innerWidth <= 768

            if (!this.isOnMobile) {
                const savedState = this.loadSidebarState()
                if (savedState !== null) {
                    this.setSidebarVisibility(savedState)
                } else {
                    this.setSidebarVisibility(true)
                }
            } else {
                if (!this.isInputFocused) {
                    this.setSidebarVisibility(false)
                }
            }

            if (this.isMobileLandscape) {
                this.isFooterOpen = false
            } else {
                this.isFooterOpen = true
            }
        },
        handleItemClick(itemId: any) {
            this.openItemId = itemId === this.openItemId ? null : itemId
        },
        onExitImpersonationClick() {
            this.$store.dispatch("auth/unimpersonate")
        },
        sidebarMaxWidth() {
            if (this.isOnMobile) {
                return this.isSidebarVisible ? "100%" : "0"
            }

            const sidebarWidth = this.isSidebarVisible ? "360px" : "50px"

            // Dynamically set the contentRef padding-left
            if (this.contentRef) {
                this.contentRef.style.marginLeft = sidebarWidth
            }

            return sidebarWidth
        },
        onManageClick() {
            if (!this.showManageOption) {
                return
            }

            this.onItemClick2()
            this.$router.push(this.manageUrl)
        },
        processRouteChange() {
            if (
                !this.$permissions.hasSuperAdminRole() &&
                this.sidebarMenu.length >= 1 &&
                this.$route.fullPath === "/"
            ) {
                if (
                    this.$permissions.hasBasicUserRole() &&
                    this.sidebarMenu[0]?.children.length >= 1
                ) {
                    let location = this.sidebarMenu[0].children.find(
                        (child: any) => child.type === "location",
                    )

                    if (location) {
                        return this.$router.push(location.href)
                    }
                }

                let location = this.sidebarMenu[0]
                this.$router.push(location.href)
            }
        },
        normalizeString(str: string): string {
            return str
                .toLocaleLowerCase()
                .replace(/š/g, "s")
                .replace(/č/g, "c")
                .replace(/ž/g, "z")
                .replace(/ć/g, "c")
                .replace(/ç/g, "c")
                .replace(/đ/g, "d")
                .replace(/ä/g, "a")
                .replace(/ö/g, "o")
                .replace(/ü/g, "u")
                .replace(/å/g, "a")
                .replace(/é/g, "e")
                .replace(/à/g, "a")
                .replace(/â/g, "a")
                .replace(/ê/g, "e")
                .replace(/ë/g, "e")
                .replace(/î/g, "i")
                .replace(/ï/g, "i")
                .replace(/ô/g, "o")
                .replace(/û/g, "u")
        },
        filterNodeEntries(node: any): any {
            const query = this.normalizeString(this.query)
            let matches: any[] = []

            if (query.length === 0) {
                return node
            }

            if (node.children) {
                for (const child of node.children) {
                    const childMatches = this.filterNodeEntries(child)
                    let filteredTitle = this.normalizeString(child.title).includes(query)

                    if (childMatches !== null || filteredTitle) {
                        if (node.type === "device-group" && childMatches !== null) {
                            matches.push({ ...child, filtered: true, filteredTitle })
                        } else {
                            matches.push(childMatches)
                        }
                    }
                }
            }

            if (this.normalizeString(node.title).includes(query)) {
                let filteredNode = { ...node, filtered: true, filteredTitle: true }

                return filteredNode
            }

            if (matches.length === 0) {
                return null
            }

            return { ...node, children: matches, filtered: true }
        },
        toggleFooter() {
            this.isFooterOpen = !this.isFooterOpen
        },
        onSearchFocus() {
            this.setInputFocused(true)
        },
        onSearchBlur() {
            this.setInputFocused(false)
        },
        handleLogoClick() {
            if (this.isOnMobile) {
                this.setSidebarVisibility(false)
            }
        },

        goToHome() {
            const user: any = this.$auth.user()

            if (user?.role === "ROLE_SUPER_ADMIN") {
                return "/"
            }

            if (user?.role === "ROLE_AGGREGATOR") {
                return this.homeHref
            }

            if (user?.role === "ROLE_USER_BASIC") {
                if (!user.permissions?.locations?.length || !this.homeHref) {
                    return "/setup"
                } else {
                    return this.homeHref
                }
            }

            return "/"
        },
        saveSidebarState() {
            if (!this.isOnMobile) {
                localStorage.setItem("sidebarVisible", JSON.stringify(this.isSidebarVisible))
            }
        },
        loadSidebarState() {
            if (!this.isOnMobile) {
                const savedState = localStorage.getItem("sidebarVisible")
                if (savedState !== null) {
                    return JSON.parse(savedState)
                }
            }
            return null
        },
        toggleSidebar() {
            this.setSidebarVisibility(!this.isSidebarVisible)
            this.saveSidebarState()
        },
        hasLocationGroupInMenu(groupId: number, companyId: number) {
            // Check if we already have any location groups from this company in the menu
            return this.sidebarMenu.some((item: any) =>
                item.children?.some(
                    (group: any) =>
                        group.type === "location-group" && group.companyId === companyId,
                ),
            )
        },
        getGroupCompany(groupId: number) {
            const locationGroup = this.$store.getters["auth/user"]?.locationGroups?.find(
                (g: any) => g.id === groupId,
            )
            return locationGroup?.companyId
        },
        scrollToActiveMenuItem() {
            const sidebarWrapper = document.getElementById("main-sidebar-content-wrapper")
            if (!sidebarWrapper) {
                return
            }

            const allActiveItems = sidebarWrapper.querySelectorAll(
                ".menu-item-active, .sub-menu-item-active",
            )

            let deepestActiveItem: HTMLElement | null = null
            let maxLevel = -1

            allActiveItems.forEach((container) => {
                const titleElement = container.querySelector(".menu-item-title")
                if (titleElement) {
                    const href = titleElement.getAttribute("href")
                    const currentPath = this.$route.path

                    if (href === currentPath) {
                        const levelMatch = container.className.match(/menu-item-level-(\d+)/)
                        const level = levelMatch ? parseInt(levelMatch[1]) : 0

                        if (level > maxLevel) {
                            maxLevel = level
                            deepestActiveItem = titleElement as HTMLElement
                        }
                    }
                }
            })

            if (deepestActiveItem) {
                const itemElement = deepestActiveItem as HTMLElement
                const wrapperRect = sidebarWrapper.getBoundingClientRect()
                const itemRect = itemElement.getBoundingClientRect()

                const isVisible =
                    itemRect.top >= wrapperRect.top && itemRect.bottom <= wrapperRect.bottom

                if (!isVisible) {
                    const itemPositionInList =
                        sidebarWrapper.scrollTop + (itemRect.top - wrapperRect.top)

                    const scrollTarget =
                        itemPositionInList - wrapperRect.height / 2 + itemRect.height / 2

                    sidebarWrapper.scrollTop = scrollTarget
                }
            }
        },
    },
    watch: {
        companyId: function (value) {
            const user = this.$auth.user()

            //@ts-ignore Fix type
            if (user.role === "ROLE_SUPER_ADMIN" && value) {
                this.query = ""
                this.isMenuRendering = true

                this.fetchMenu(value).then(() => {
                    this.processRouteChange()
                })
            }
        },
        locationGroupId: function (value) {
            const user = this.$auth.user()

            //@ts-ignore Fix type
            if (user.role === "ROLE_AGGREGATOR" && value) {
                const companyId = this.getGroupCompany(value)
                const hasGroupsFromCompany = this.hasLocationGroupInMenu(value, companyId)

                if (!hasGroupsFromCompany) {
                    this.isMenuRendering = true
                    this.fetchMenu().then(() => {
                        this.processRouteChange()
                    })
                }
            }
        },
        $route: {
            handler: function (to, from) {
                if (this.isOnMobile) {
                    this.setSidebarVisibility(false)
                }

                const user = this.$auth.user()

                //@ts-ignore Fix type
                if (user.role === "ROLE_USER_BASIC") {
                    const menuRoutes = ["/companies", "/location-groups", "/locations"]

                    const isComingFromMenuRoute = from?.path
                        ? menuRoutes.some((route) => from.path.startsWith(route))
                        : false

                    if (!from?.path || !isComingFromMenuRoute) {
                        this.isMenuRendering = true
                        this.fetchMenu().then(() => {
                            this.processRouteChange()
                        })
                    }
                }

                if (this.sidebarMenu) {
                    this.processRouteChange()
                }
            },
            immediate: true,
        },
        showMenu: function (value) {
            if (!value) {
                this.setMenu([])
            }
        },
        query: function (newVal, oldVal) {
            if (oldVal && newVal === "") {
                this.$nextTick(() => {
                    requestAnimationFrame(() => {
                        this.scrollToActiveMenuItem()
                    })
                })
            }
        },
        sidebarMenu: {
            handler() {
                this.$nextTick(() => {
                    requestAnimationFrame(() => {
                        this.scrollToActiveMenuItem()
                        this.isMenuRendering = false
                    })
                })
            },
            deep: true,
        },
    },
    mounted() {
        this.onResize()

        if (!this.isOnMobile) {
            const savedState = this.loadSidebarState()
            if (savedState !== null) {
                this.setSidebarVisibility(savedState)
            } else {
                this.setSidebarVisibility(true)
            }
        }

        window.addEventListener("resize", this.handleResize)

        if (this.isMobileLandscape) {
            this.isFooterOpen = false
        }

        nextTick(() => {
            if (this.isOnMobile) {
                this.setSidebarVisibility(false)
            }

            window.addEventListener("resize", this.onResize)

            const user = this.$auth.user()

            //@ts-ignore Fix type
            if (user.role !== "ROLE_USER_BASIC") {
                const isAdmin = this.$permissions.hasSuperAdminRole() ? this.companyId : null

                this.isMenuRendering = true
                this.fetchMenu(isAdmin).then(() => {
                    this.processRouteChange()
                })

                this.setLoading(false)
            }
        })
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize)
        window.removeEventListener("resize", this.onResize)
    },
    computed: {
        ...mapGetters("sidebar", {
            sidebarMenu: "sidebarMenu",
            isSidebarVisible: "isSidebarVisible",
            isSidebarLoading: "isSidebarLoading",
            selectedCompany: "company",
            lastLocationId: "locationId",
            location: "location",
            homeHref: "homeHref",
            isInputFocused: "isInputFocused",
        }),
        ...mapGetters("auth", {
            isImpersonating: "impersonating",
        }),
        ...mapGetters("appLayoutModule", {
            contentRef: "contentRef",
            isLayoutMobile: "isMobile",
            isLayoutMobileLandscape: "isLandscapeMobile",
        }),
        filteredMenu() {
            if (this.isSidebarLoading) {
                return []
            }

            if (this.sidebarMenu.length === 0) {
                return []
            }

            let filteredMenu: any[] = []

            this.sidebarMenu.forEach((item: any) => {
                const rootMatches = this.filterNodeEntries(item)

                if (rootMatches !== null) {
                    filteredMenu.push({
                        ...rootMatches,
                        filtered: this.query.length > 0,
                    })
                }
            })

            return filteredMenu
        },
        showManageOption(): boolean {
            return (
                this.locationId != null &&
                this.$permissions.can("edit", "location", this.locationId)
            )
        },
        companyId() {
            return Number.parseInt(this.$route.params.companyId) || null
        },
        locationId() {
            return Number.parseInt(this.$route.params.locationId) || null
        },
        locationGroupId() {
            return Number.parseInt(this.$route.params.locationGroupId) || null
        },
        manageUrl: function () {
            let url = "/"

            if (this.companyId) {
                url += "companies/" + this.companyId + "/"
            }

            if (this.locationGroupId) {
                url += "location-groups/" + this.locationGroupId + "/"
            }

            if (this.locationId) {
                url += "locations/" + this.locationId + "/"
            }

            url += "manage"

            return url
        },
        logoUrl() {
            let savedLogo = this.$store.getters["reduxi/getSiteLogo"]

            if (savedLogo) {
                return savedLogo
            }

            // @ts-ignore Fix type
            return require(`@/assets/brands/${this.$brand}/images/logo.svg`)
        },
        showMenu() {
            return !!(this.companyId || this.locationId || this.locationGroupId)
        },
        showAdminSearch() {
            return this.$route.meta?.showAdminSearch
        },
        showMojElektroSidebar() {
            return this.$route.meta?.showMojElektroSidebar
        },
        showBackButton() {
            return this.$route.meta?.showBackButton
        },
        isMobileLandscape() {
            const isMobileUserAgent =
                /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                    navigator.userAgent,
                )
            const isLandscape = this.windowHeight < this.windowWidth

            return isMobileUserAgent && isLandscape
        },
        showSidebarStructure() {
            const routesToShowMenu = ["/companies", "/location-groups", "/locations"]

            const showRoute = routesToShowMenu.some((route) => this.$route.path.startsWith(route))

            return showRoute
        },
        isUserBasic() {
            const user = this.$auth.user()

            //@ts-ignore
            return user.role === "ROLE_USER_BASIC"
        },
    },
}
</script>

<template>
    <div
        class="sidebar"
        :style="{ maxWidth: sidebarMaxWidth() }"
        :class="{
            closed: !isSidebarVisible && isOnMobile,
            collapsed: !isSidebarVisible && !isOnMobile,
        }"
    >
        <div class="sidebar-header">
            <div v-if="isSidebarVisible" class="text-center sidebar-logo">
                <router-link :to="goToHome()" @click.native="handleLogoClick">
                    <img :src="logoUrl" class="logo" alt="logo" />
                </router-link>
                <span
                    v-if="isLayoutMobile && !isLayoutMobileLandscape"
                    class="menu-mobile-close expand-icon-wrapper"
                    @click="closeSidebar"
                >
                    <i class="fas fa-times fa-2x text-primary"></i>
                </span>
            </div>
            <button
                v-if="!isLayoutMobile || isLayoutMobileLandscape"
                class="sidebar-toggle-button"
                @click="toggleSidebar"
                :aria-expanded="isSidebarVisible"
            >
                <i :class="isSidebarVisible ? 'fas fa-chevron-left' : 'fas fa-chevron-right'"></i>
            </button>
            <div
                class="border-left border-danger d-flex justify-content-between align-items-center py-2 px-4"
                v-if="isImpersonating && isSidebarVisible"
            >
                <span class="text-danger">{{ $t("Impersonating user!") }}</span>
                <button class="btn btn-sm btn-danger text-white" @click="onExitImpersonationClick">
                    {{ $t("Stop") }}
                </button>
            </div>
            <div v-if="showSidebarStructure && isSidebarVisible" class="search-form input-group">
                <input
                    type="text"
                    name="query"
                    class="search form-control px-2"
                    v-model="query"
                    :placeholder="$t('Search').toString()"
                    autocomplete="off"
                    @focus="onSearchFocus"
                    @blur="onSearchBlur"
                />
                <button
                    v-if="query.length > 0"
                    type="button"
                    class="btn bg-transparent"
                    style="margin-left: -40px; z-index: 100"
                    @click="query = ''"
                >
                    <i class="fa fa-times text-primary"></i>
                </button>
            </div>
        </div>
        <SidebarMenuNew
            class="sidebar-content"
            :menu="filteredMenu"
            :open-item-id="openItemId || ''"
            :is-loading="isMenuRendering"
            @item-click="handleItemClick"
            v-if="showSidebarStructure && isSidebarVisible"
        />
        <div v-else style="flex: 1 1 auto"></div>

        <div v-if="showAdminSearch && isSidebarVisible" class="h-100 overflow-hidden">
            <FilteredSearch />
        </div>
        <div v-if="showMojElektroSidebar && isSidebarVisible" class="h-100 overflow-hidden">
            <MojElektroFilters />
        </div>
        <div
            :class="[
                'sidebar-footer',
                { 'footer-closed': !isFooterOpen, 'pt-2': !isMobileLandscape },
            ]"
            v-if="isSidebarVisible"
        >
            <div class="w-100 d-flex my-2" v-if="isMobileLandscape">
                <button
                    @click="toggleFooter"
                    class="toggle-footer-button w-100 border-0"
                    style="background-color: var(--theme-primary); color: var(--theme-tertiary)"
                >
                    <i :class="isFooterOpen ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
                </button>
            </div>
            <template v-if="isFooterOpen">
                <a
                    v-if="showManageOption"
                    class="btn btn-sidebar btn-sidebar-full p-3 mb-2"
                    @click.prevent="onManageClick"
                    :href="manageUrl"
                >
                    <i class="fa fa-solid fa-location-crosshairs text-primary"></i>
                    <span>{{ $t("Manage Location") }}</span>
                </a>
                <router-link
                    v-if="isUserBasic"
                    :to="{ path: '/setup' }"
                    class="btn btn-sidebar btn-sidebar-full p-3 mb-2"
                    @click.native="onItemClick2"
                >
                    <i class="fa fa-solid fa-layer-group text-primary"></i>
                    <span>{{ $t("setup.title") }}</span>
                </router-link>
                <router-link
                    :to="{ path: '/user/settings' }"
                    class="btn btn-sidebar btn-sidebar-full p-3 mb-2"
                    @click.native="onItemClick2"
                >
                    <i class="fa fa-solid fa-gear text-primary"></i>
                    <span>{{ $t("User settings") }}</span>
                </router-link>
                <router-link
                    :to="{
                        path: companyId
                            ? `/settings/global/companies/${companyId}`
                            : '/settings/global',
                    }"
                    class="btn btn-sidebar btn-sidebar-full p-3 mb-2"
                    v-if="$permissions.hasAggregatorRole()"
                >
                    <i class="fa fa-solid fa-globe text-primary"></i>
                    <span class="user-title">{{ $t("Global Settings") }}</span>
                </router-link>
                <div
                    v-if="showBackButton"
                    class="btn btn-sidebar btn-sidebar-full p-3 mb-2"
                    @click="onBackButtonClick"
                >
                    <i class="fa fa-solid fa-arrow-turn-up text-primary rotate"></i>
                    <span class="user-title">{{ $t("Back") }}</span>
                </div>
            </template>
        </div>
    </div>
</template>

<style>
.rotate {
    transform: rotate(-90deg);
}

.sidebar {
    transition: max-width 0.3s ease-in-out;
    overflow: hidden;
}

.sidebar.collapsed {
    max-width: 50px;
}

.sidebar.collapsed .sidebar-content,
.sidebar.collapsed .sidebar-header .search-form,
.sidebar.collapsed .sidebar-footer {
    display: none;
}

.sidebar.collapsed .sidebar-toggle-button {
    position: absolute;
    top: 10px;
    left: 0px;
}

.expand-icon-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 50px;
    margin: -15px;
    cursor: pointer;
}

.sidebar-toggle-button {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;
    background: transparent;
    color: var(--theme-tertiary);
    border: none;
    width: 45px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.sidebar-toggle-button i {
    font-size: 18px;
}

.cursor-pointer {
    cursor: pointer;
}
</style>
